import Vue from "vue";
import http from "../utils/http";
import moment from "moment";

function formatarParamsBusca(params) {
  const dataBuscaInicio = moment(params.data[0]).format("DD/MM/YYYY") + " 00:00:00";
  const dataBuscaFim = moment(params.data[1]).format("DD/MM/YYYY")+ " 23:59:59";
  return {
    modalidade: params.modalidade ? [params.modalidade] : [],
    dataBuscaInicio: dataBuscaInicio,
    dataBuscaFim: dataBuscaFim,
    tipoDataBusca: "DATA_ESTUDO",
    nomePaciente: params.nome ? params.nome : "",
    pacienteID: params.pacienteID ? params.pacienteID : "",
    numeroAcesso: params.numeroAcesso ? params.numeroAcesso : ""
  };
}

export default {
  buscar(data) {
    const config = {
      method: "post",
      url: "/api/busca/",
      data: formatarParamsBusca(data)
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao buscar os estudos."
          });
          reject(e);
        });
    });
  },
  series(data) {
    const config = {
      method: "post",
      url: `/api/info/estudo/serie/?estudoInstanciaUID=${data.estudoInstanciaUID}`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao carregar as series."
          });
          reject(e);
        });
    });
  },
  instancias(data) {
    const config = {
      method: "post",
      url: `/api/info/serie/instancia/?serieInstanciaUID=${data.serieInstanciaUID}`
    };
    return new Promise((resolve, reject) => {
      http(config)
        .then(resp => {
          resolve(resp);
        })
        .catch(e => {
          Vue.notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: "Ocorreu um erro ao carregar as series."
          });
          reject(e);
        });
    });
  },
  lixeira(params){
    const config = {
      method: "get",
      url: "/api/estudo/lixeira",
      data: {servidor: params.servidor}
    };
    return new Promise((resolve, reject) => {
      http(config)
          .then(resp => {
            resolve(resp);
          })
          .catch(e => {
            Vue.notify({
              group: "geral",
              type: "error",
              title: "Ops!",
              text: "Ocorreu um erro ao carregar lixeira."
            });
            reject(e);
          });
    });
  }
};
